var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.644,
    height: 40.2,
    viewBox: "0 0 39.644 40.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "E-learning_on_computer",
    transform: "translate(-15.033 -11.62)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M240.651,359.586a1.369,1.369,0,1,0,1.365,1.369A1.369,1.369,0,0,0,240.651,359.586Zm0,1.92a.55.55,0,1,1,.55-.55.55.55,0,0,1-.55.55Z",
    transform: "translate(-205.794 -319.385)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M52,18.466H49.064v-2.1a1.6,1.6,0,0,0-1.388-1.578c-.232-.03-.5-.061-.8-.092v-.144a1.088,1.088,0,0,0-.905-1.077,20.4,20.4,0,0,0-3.62-.284v-.463A1.006,1.006,0,0,0,41.35,11.72H39.5a2.735,2.735,0,0,0-2.732,2.732v.142h0A5.971,5.971,0,0,0,35.3,15.9a.8.8,0,0,1-.63.3.792.792,0,0,1-.348-.08.8.8,0,0,1-.282-.226,7.971,7.971,0,0,0-5.709-2.637,19.45,19.45,0,0,0-4.958.208,1.088,1.088,0,0,0-.905,1.077v.144c-.3.03-.563.061-.8.092a1.6,1.6,0,0,0-1.388,1.578v2.1H17.715a2.585,2.585,0,0,0-2.582,2.581V42.162a2.585,2.585,0,0,0,2.582,2.588H31.76L30.918,50.9h-2a.409.409,0,0,0,0,.819H40.948a.409.409,0,1,0,0-.819h-2l-.095-.69-.747-5.461H52a2.585,2.585,0,0,0,2.582-2.582V21.047A2.584,2.584,0,0,0,52,18.467ZM23.288,14.549a.273.273,0,0,1,.226-.271c1.693-.287,7.407-.98,9.891,2.133a1.62,1.62,0,0,0,.861.561V28.78a.409.409,0,0,0,.819,0V16.972a1.621,1.621,0,0,0,.861-.561,5.015,5.015,0,0,1,.822-.814h0v2.841a.791.791,0,0,0,.565.76.8.8,0,0,0,.232.034.79.79,0,0,0,.659-.355l.508-.764.508.764a.795.795,0,0,0,1.456-.44V16.447a.409.409,0,1,0-.819,0v1.911l-.8-1.207a.409.409,0,0,0-.682,0l-.8,1.207V14.272a.8.8,0,0,1,.018-.138,1.911,1.911,0,0,1,1.886-1.6H41.35a.188.188,0,0,1,.187.187v.5h0q-.262.016-.527.042c-.108.011-.213.022-.318.036q-.422.05-.819.126v.836h0V15a.409.409,0,0,0,.819,0v-.873a18.373,18.373,0,0,1,5.139.154.273.273,0,0,1,.226.271V28.933a.272.272,0,0,1-.089.2.279.279,0,0,1-.212.071c-6.07-.541-9.225,1.332-10.56,2.5a.824.824,0,0,1-.113.081V30.276a.409.409,0,0,0-.819,0v1.5a.824.824,0,0,1-.113-.081c-1.177-1.023-3.752-2.591-8.475-2.591-.655,0-1.351.03-2.09.1a.275.275,0,0,1-.3-.273ZM21.1,16.36a.774.774,0,0,1,.675-.765c.2-.026.435-.054.69-.08V28.93a1.092,1.092,0,0,0,1.192,1.088c5.769-.514,8.713,1.219,9.957,2.3a1.622,1.622,0,0,0,2.119,0c1.241-1.079,4.185-2.816,9.957-2.3a1.092,1.092,0,0,0,1.188-1.088V15.522c.254.026.487.054.69.08a.774.774,0,0,1,.675.765V30.42a.771.771,0,0,1-.821.769c-6.085-.4-9.531,1.131-11.351,2.483a2.333,2.333,0,0,1-2.8,0c-1.62-1.207-4.531-2.548-9.444-2.548q-.905,0-1.911.064a.771.771,0,0,1-.821-.769Zm-5.149,4.684a1.764,1.764,0,0,1,1.76-1.759h2.569v2.738h-4.33ZM38.125,50.9h-6.38l.842-6.151h4.7Zm15.634-12.52H49.707a.409.409,0,1,0,0,.819h4.051v2.968A1.764,1.764,0,0,1,52,43.931H17.715a1.765,1.765,0,0,1-1.763-1.763V39.2H47.873a.409.409,0,0,0,0-.819H15.954V22.842h4.331V30.42a1.59,1.59,0,0,0,1.693,1.587c5.833-.38,9.1,1.054,10.81,2.323a3.15,3.15,0,0,0,3.775,0c1.71-1.27,4.973-2.7,10.81-2.323a1.59,1.59,0,0,0,1.693-1.587V22.842h4.694Zm0-16.36H49.064V19.284H52a1.764,1.764,0,0,1,1.763,1.762Z",
    transform: "translate(0 0)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M286.683,121.844a.409.409,0,0,0,.258-.093c.076-.062,1.911-1.509,5.356-.6a.409.409,0,0,0,.208-.792c-3.874-1.018-6,.694-6.085.767a.409.409,0,0,0,.263.723Z",
    transform: "translate(-248.94 -99.444)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M286.683,151.646a.409.409,0,0,0,.258-.093c.076-.062,1.911-1.509,5.356-.6a.409.409,0,1,0,.208-.792c-3.874-1.018-6,.694-6.085.766a.409.409,0,0,0,.263.723Z",
    transform: "translate(-248.94 -126.806)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M286.683,181.445a.409.409,0,0,0,.258-.092c.076-.062,1.911-1.509,5.356-.6a.409.409,0,1,0,.208-.792c-3.874-1.018-6,.694-6.085.767a.409.409,0,0,0,.263.723Z",
    transform: "translate(-248.94 -154.165)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M140.347,120.855a.409.409,0,0,0,.5.292c3.439-.905,5.274.54,5.355.6a.41.41,0,0,0,.522-.632c-.089-.073-2.213-1.785-6.085-.767a.409.409,0,0,0-.295.5Z",
    transform: "translate(-114.948 -99.445)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M140.639,150.155a.409.409,0,0,0,.208.792c3.439-.905,5.274.54,5.356.6a.409.409,0,1,0,.521-.632C146.636,150.849,144.513,149.137,140.639,150.155Z",
    transform: "translate(-114.948 -126.805)",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M140.639,179.957a.409.409,0,0,0,.208.792c3.439-.905,5.274.54,5.356.6a.409.409,0,1,0,.521-.632C146.636,180.65,144.513,178.939,140.639,179.957Z",
    transform: "translate(-114.948 -154.167)",
    stroke: "#fff",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubject);
export default __webpack_public_path__ + "static/media/subject.21682c8d2890ecc265031bad5a30aa22.svg";
export { ForwardRef as ReactComponent };